import { BlockValueTemplateInnerField } from '../CodeMirror/FlowTemplate';
import { type ConfigFieldProps } from '../types';

interface DynamicFieldTemplateValueProps extends ConfigFieldProps {
  fieldId: string;
}

export function DynamicFieldTemplateValue(props: DynamicFieldTemplateValueProps) {
  const { fieldId, fieldName } = props;
  return (
    <BlockValueTemplateInnerField
      fieldId={fieldId}
      fieldName={`${fieldName}.template`}
      isMultiline
      label="Template value"
    />
  );
}
